export default "__VITE_ASSET__CdF5KRXe__"